export default __webpack_public_path__ + "99b1806a434d4be795e3b33fecc39c3a.svg";